import { memo } from 'react';
import { AccordionSection } from '../../../shared/components/AccordionSection';
import { InsuranceReportAccordionProvider } from '../../../shared/context/AccordionContext';
import { useDentalInsuranceReportContext } from '../context/DentalInsuranceReportDetailsContext.provider';
import { getInsuranceBenefitKeys, getInsuranceReportAccordionIds } from '../helper';
import { TablesDataType } from '../types/types';
import { reorderByPriority } from '../utils/utils';
import { InsuranceReportAccordionSection } from './InsuranceTables/InsuranceReportAccordionSection';

type AccordionInsuranceTablesProps = {
  isPrintReport?: boolean;
};
export const AccordionInsuranceTables = memo(({ isPrintReport = false }: AccordionInsuranceTablesProps) => {
  const ACCORDION_RENDER_PRIORITY: (keyof TablesDataType)[] = ['activeCoverage', 'maximum', 'deductible', 'limitation'];

  const { tablesData: filteredTablesData, segregatedTablesDataByNetwork } = useDentalInsuranceReportContext();
  const allTablesData = {
    ...segregatedTablesDataByNetwork.in_network,
    ...Object.fromEntries(
      Object.entries(segregatedTablesDataByNetwork.out_network).filter(
        ([_, value]) => Array.isArray(value) && value.length > 0
      )
    ),
  };
  const accordionSectionList = getInsuranceBenefitKeys(isPrintReport ? allTablesData : filteredTablesData);
  const reorderedAccordionSectionList = reorderByPriority<keyof TablesDataType>(
    accordionSectionList,
    ACCORDION_RENDER_PRIORITY
  );

  const { accordionIds, accordionList } = getInsuranceReportAccordionIds(
    reorderedAccordionSectionList as (keyof TablesDataType)[]
  );

  return (
    <InsuranceReportAccordionProvider isPrintReport={isPrintReport} accordionIds={accordionIds}>
      {accordionList?.map((accordion) => (
        <AccordionSection key={accordion.id} accordionTitle={accordion.label} accordionId={accordion.id}>
          <InsuranceReportAccordionSection accordionId={accordion.id} />
        </AccordionSection>
      ))}
    </InsuranceReportAccordionProvider>
  );
});

AccordionInsuranceTables.displayName = 'InsuranceTables';
